import React from 'react';
import GenericSvgIcon from "./GenericSvgIcon";
import IconType from "@/types/Icon.type";

function IconBrandGlobe(props: IconType) {
    const {
        width = '16',
        height = '16',
        fill = "#7e00d9",
        viewBox = '0 0 16 16',
        title = 'IconBrandGlobe',
        ...rest
    } = props

    return (
        <GenericSvgIcon
            width={width}
            height={height}
            fill={fill}
            viewBox={viewBox}
            title={title}
            {...rest}
            svgIconPath={(
                <g fill={fill} transform="translate(1.8689 1.8689)">
                    <path
                        d="m6.1311045-.6c2.65598425 0 5.0301005 1.55263681 6.1195112 3.92408393l-1.0904425.50093445c-.8954509-1.94923244-2.8462382-3.22501838-5.0290687-3.22501838-3.05474467 0-5.5311045 2.47635983-5.5311045 5.5311045 0 3.05474466 2.47635983 5.5311045 5.5311045 5.5311045 2.4353209 0 4.5751263-1.572265 5.2967311-3.83649899.158023-.49584077.2343734-1.06401911.2343734-1.69460551h1.2c0 .74715146-.0926214 1.43641445-.2910328 2.05898482-.8798474 2.76076388-3.48114527 4.67211968-6.4400717 4.67211968-3.71748637 0-6.7311045-3.01361814-6.7311045-6.7311045 0-3.71748637 3.01361813-6.7311045 6.7311045-6.7311045z"/>
                    <path
                        d="m2.44771959 4.95684401 1.19420218.11781829c-.03411048.34574271-.05142834.69890861-.05142834 1.0564422 0 3.09868062 1.30572951 5.5311045 2.69118794 5.5311045v1.2c-2.24988739 0-3.89118794-3.05755411-3.89118794-6.7311045 0-.39680846.01924596-.78929447.05722616-1.17426049zm3.83396178-5.55684401v1.2c-.8796608 0-1.78837364 1.01384247-2.29901746 2.71268009l-1.14920659-.34543339c.64557227-2.1477249 1.91789783-3.5672467 3.44822405-3.5672467z"/>
                    <path
                        d="m9.68473494-.6v1.2c-.8796608 0-1.78837364 1.01384247-2.29901746 2.71268009-.16365416.54445354-.27925703 1.13877122-.34074214 1.76198221-.03411048.34574271-.05142834.69890861-.05142834 1.0564422 0 3.09868062 1.30572952 5.5311045 2.69118794 5.5311045v1.2c-2.24988739 0-3.89118794-3.05755411-3.89118794-6.7311045 0-.39680846.01924596-.78929447.05722616-1.17426049.06897981-.699177.19940433-1.36969321.38573773-1.98959731.64557227-2.1477249 1.91789783-3.5672467 3.44822405-3.5672467z"
                        transform="matrix(-1 0 0 1 15.4782 0)"/>
                    <path
                        d="m9.91354083 7.69905823c.33137087 0 .59999997.26862915.59999997.6s-.2686291.6-.59999997.6h-7.68630453c-.33137085 0-.6-.26862915-.6-.6s.26862915-.6.6-.6z"/>
                    <path
                        d="m9.91354083 3.49537584c.33137087 0 .59999997.26862915.59999997.6s-.2686291.6-.59999997.6h-7.68630453c-.33137085 0-.6-.26862915-.6-.6s.26862915-.6.6-.6z"/>
                </g>
            )}
        />

    );
}

export default IconBrandGlobe;
